export default {
  name: "development",
  metaInfo: {
    title: 'Development | Canvas Development',
    meta: [
      {
        name: 'keywords',
        content: 'web development'
      },
      {
        name: 'description',
        content: 'From A to Z, we have your next project covered, guaranteed. We specialize in Web Applications, eCommerce and Mobile Apps.'
      }
    ]

  },
  data() {
    return {
      more: false,
      simple: [
        {
          tin: 'timwsefmdsm,'
        },
        {
          tin: 'sdasdasd'
        }
      ],
      listItems: [
        [
          {
            title2: 'Prog. Languages'
          },
          {
            title: 'PHP'
          },
          {
            title: 'Bootstrap'
          },
          {
            title: 'C',
          },
          {
            title: 'C#'
          },
          {
            title: 'C++'
          },
          {
            title: 'Coffeescript'
          },
          {
            title: 'CSS'
          },
          {
            title: 'Haml'
          },
          {
            title: 'HTML'
          },
          {
            title: 'JAVA'
          },
          {
            title: 'Javascript'
          },
          {
            title: 'JSON'
          },
          {
            title: 'JSP'
          },
          {
            title: 'Less'
          },
          {
            title: 'Python'
          },
          {
            title: 'Ruby'
          },
          {
            title: 'Scala'
          },
          {
            title: 'SERVLET'
          },
          {
            title: 'Slim'
          },
          {
            title: 'SQL'
          },
          {
            title: 'SQL'
          },
          {
            title: 'UML'
          },
          {
            title: 'XML'
          }
        ],
        [
          {
            title2: 'FRAMEWORK'
          },
          {
            title: 'AJAX'
          },
          {
            title: 'Drupal'
          },
          {
            title: 'Hibernate',
          },
          {
            title: 'Joomla'
          },
          {
            title: 'jQuery'
          },
          {
            title: 'JSF'
          },
          {
            title: 'Play'
          },
          {
            title: 'Richfaces'
          },
          {
            title: 'Ruby on Rails'
          },
          {
            title: 'Sinatra'
          },
          {
            title: 'Sping MVC'
          },
          {
            title: 'Spring'
          }
        ],
        [
          {
            title2: 'DATABASE'
          },
          {
            title: 'CouchDB'
          },
          {
            title: 'Memcached'
          },
          {
            title: 'MongoDB',
          },
          {
            title: 'MS Access'
          },
          {
            title: 'MS SQL Server'
          },
          {
            title: 'MySQL'
          },
          {
            title: 'Oracle'
          },
          {
            title: 'PL/SQL'
          },
          {
            title: 'PostGreSQL'
          },
          {
            title: 'Redis'
          },
          {
            title: 'SQLite'
          },
          {
            title: 'Sybase'
          }
        ],
        [
          {
            title2: 'TOOLS'
          },
          {
            title: 'Eclipse'
          },
          {
            title: 'Gedit'
          },
          {
            title: 'Illustrator',
          },
          {
            title: 'InDesign'
          },
          {
            title: 'Ireports'
          },
          {
            title: 'Iterm'
          },
          {
            title: 'JBuilder'
          },
          {
            title: 'JFreeChart'
          },
          {
            title: 'MS Visio'
          },
          {
            title: 'MS Visual Studio'
          },
          {
            title: 'NetBeans'
          },
          {
            title: 'Oracle Discover'
          },
          {
            title: 'Photoshop'
          },
          {
            title: 'Sublime Text 3'
          },
          {
            title: 'Terminal'
          },
          {
            title: 'Terminator'
          },
          {
            title: 'Vim'
          }
        ],
        [
          {
            title2: 'SERVER'
          },
          {
            title: 'Apache'
          },
          {
            title: 'AWS'
          },
          {
            title: 'EC2',
          },
          {
            title: 'cPanel/WHM',
          },
          {
            title: 'Linode',
          },
          {
            title: 'Nginx',
          }
        ],
        [
          {
            title2: 'OTHER'
          },
          {
            title: 'Agile'
          },
          {
            title: 'Android'
          },
          {
            title: 'Bazaar',
          },
          {
            title: 'GIT',
          },
          {
            title: 'REST',
          },
          {
            title: 'Scrum',
          },
          {
            title: 'SOA',
          },
          {
            title: 'SVN',
          },
          {
            title: 'TDD'
          }
        ]
      ],
      items: [
        {
          src: 'https://ik.imagekit.io/canvasdev/nodejs-logo_hjk8zsV-P2.jpg'
        },
        {
          src: 'https://ik.imagekit.io/canvasdev/vuejs-logo_liv8vBibOf.jpg'
        },
        {
          src: 'https://ik.imagekit.io/canvasdev/express-logo_PbKVF9uAz.jpg'
        },
        {
          src: 'https://ik.imagekit.io/canvasdev/shopify-logo_7AmPySItAQ.jpg'
        },
        {
          src: 'https://ik.imagekit.io/canvasdev/wordpress-logo_pH2F4R3km.jpg'
        },
        {
          src: 'https://ik.imagekit.io/canvasdev/codeigniter-logo_dxPSWh9po.jpg'
        }
      ],
      standout: [
        {
          icon: "https://ik.imagekit.io/canvasdev/support-icon_1Rfc8_B85.png",
          title: "Advice",
          text:
            "We only succeed if our clients succeed. We’ve been doing this for a long time, so we can provide valuable insight to help you make the best decisions and get the most out of your money."
        },
        {
          icon: "https://ik.imagekit.io/canvasdev/custom-application-icon_Bm7m18EqO.png",
          title: "Custom Applications",
          text:
            "We can make everything from scratch, or improve a CMS with a legacy site. We can use plugins to save time and money, and we’ll lay it all out for you so you get exactly what you want in the fastest time at the best price."
        },

        {
          icon: "https://ik.imagekit.io/canvasdev/project-management-icon_s6a2K5ocw.png",
          title: "Project Management",
          text:
            "You have better things to do than check to see if your developers work actually... works. So we have a group that only tests our work, and if it doesn’t meet our standards we will fix it."
        },
        {
          icon: "https://ik.imagekit.io/canvasdev/creative-design-icon_yVFhz3drE.png",
          title: "Marketing",
          text:
            "What good is your website if nobody can find it? We can help with Search Engine Optimization (SEO) and online advertising to help drive traffic."
        }
      ],
      specialize: [
        {
          icon: "https://ik.imagekit.io/canvasdev/web_application_U-0LjmOrh1.svg",
          title: "Web Applications",
          text:
            "Web development is our core work. Whether you need a complex website or just a simple splash page, providing an online presence is our specialty.",
          route: { name: "webUx" }
        },
        {
          icon: "https://ik.imagekit.io/canvasdev/eCommerce_tTopOem8I.svg",
          title: "eCommerce",
          text:
            "If you need help choosing shopping carts and payment processors, looking to migrate to a new system, or merging data from an old database, we’ve got you covered.",
          route: { name: "shopify" }
        },
        {
          icon: "https://ik.imagekit.io/canvasdev/mobile_apps_z19VGRR27m.svg",
          title: "Mobile Apps",
          text:
            "Sometimes a mobile friendly website isn’t enough. If you need to take things to the next level by creating a dedicated mobile application, we can do that!",
          route: { name: "mobileAppDevelopment" }
        }
      ]
    };
  }
};

